<template>
  <div class="calender-schedule-detail-comment-preview-component">
    <hi-dialog title="First Comment" @close="close()">
      <div class="text-container">{{ comment }}</div>
    </hi-dialog>
  </div>
</template>

<style lang="less" scoped>
@import "../../../../assets/style/theme";

.calender-schedule-detail-comment-preview-component {
  width: 375px;
  background: white;
  .text-container {
    padding: 20px;
    font-size: 14px;
    overflow: auto;
    white-space: pre-wrap;
    word-break: break-all;
    height: 200px;
    border-bottom: 1px solid @border-color;
  }
}
</style>
<script>
import hiDialog from "../../../common/dialog/Index.vue";

export default {
  name: "DetailPreviewComponent",
  components: { hiDialog },
  props: {
    comment: {
      type: String,
      default: "",
    },
  },
  methods: {
    /**
     * 关闭按钮点击事件
     */
    close() {
      this.$parent.showCommentModal = false;
    },
  },
};
</script>
